<div class="jumbotron">
    <h1 class="text-center">Compliance Report</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                <div class="p-3">
                    <div
                        cmpsTdComplianceSelectionReport
                        [params]="selectedParams"
                        [peerGroups]="peerGroups"
                        [superGroups]="superGroups"
                        [reportPopulations]="reportPopulations"
                        [callComplianceDates]="callComplianceDates"
                        (generated)="onGeneratedReport($event)"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Compliance Report
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && !noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            title="Refresh"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            title="Export"
                            (click)="onExportClick()"
                            class="btn-mini"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>

                    Report Population:
                    <b class="f-s-75-2">{{ selectedPopulationType }}</b>
                    <span class="soft-pipe">|</span>
                    Selected: <b class="f-s-75-2">{{ selectedPopulation }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Date: <b class="f-s-75-2">{{ params?.date }}</b>
                    <span class="soft-pipe">|</span>
                    Generated On:
                    <b class="f-s-75-2">{{ params?.dateRequest }}</b>

                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th colspan="3">&nbsp;</th>
                                <th
                                    class="title odd"
                                    colspan="3"
                                    [style.min-width]="'300px'"
                                >
                                    MTD
                                    <span
                                        *ngIf="dateRanges[0]"
                                        class="sub"
                                    >
                                        ({{
                                            dateRanges[0].startDate
                                                | cmpsDate: 'MMM d'
                                        }}
                                        -
                                        {{
                                            dateRanges[0].endDate
                                                | cmpsDate: 'MMM d'
                                        }})
                                    </span>
                                </th>
                                <th
                                    class="title even"
                                    colspan="3"
                                    [style.min-width]="'300px'"
                                >
                                    QTD
                                    <span
                                        *ngIf="dateRanges[1]"
                                        class="sub"
                                    >
                                        ({{
                                            dateRanges[1].startDate
                                                | cmpsDate: 'MMM d'
                                        }}
                                        -
                                        {{
                                            dateRanges[1].endDate
                                                | cmpsDate: 'MMM d'
                                        }})
                                    </span>
                                </th>
                                <th
                                    class="title odd"
                                    colspan="3"
                                    [style.min-width]="'300px'"
                                >
                                    YTD
                                    <span
                                        *ngIf="dateRanges[2]"
                                        class="sub"
                                    >
                                        ({{
                                            dateRanges[2].startDate
                                                | cmpsDate: 'MMM d yyyy'
                                        }}
                                        -
                                        {{
                                            dateRanges[2].endDate
                                                | cmpsDate: 'MMM d yyyy'
                                        }})
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <th class="subtitle">Category</th>
                                <th class="subtitle">Question</th>
                                <th class="subtitle">Objective</th>
                                <ng-template
                                    ngFor
                                    let-meta
                                    [ngForOf]="[0, 1, 2]"
                                >
                                    <th class="subtitle sorting-column">
                                        <button
                                            type="button"
                                            (click)="
                                                onClickSort('passed-' + meta)
                                            "
                                            class="btn bg-transparent p-0"
                                        >
                                            <span>Passed</span>
                                            <cmps-icon
                                                [svgIcon]="
                                                    sort['passed-' + meta]
                                                        ?.isAsc
                                                        ? 'chevron-up'
                                                        : 'chevron-down'
                                                "
                                                *ngIf="
                                                    sort &&
                                                    sort['passed-' + meta]
                                                        ?.hasSort
                                                "
                                            ></cmps-icon>
                                            <cmps-icon
                                                *ngIf="
                                                    !(
                                                        sort &&
                                                        sort['passed-' + meta]
                                                            ?.hasSort
                                                    )
                                                "
                                            ></cmps-icon>
                                        </button>
                                    </th>
                                    <th class="subtitle sorting-column">
                                        <button
                                            type="button"
                                            (click)="
                                                onClickSort('scored-' + meta)
                                            "
                                            class="btn bg-transparent p-0"
                                        >
                                            <span>Scored</span>
                                            <cmps-icon
                                                [svgIcon]="
                                                    sort['scored-' + meta]
                                                        ?.isAsc
                                                        ? 'chevron-up'
                                                        : 'chevron-down'
                                                "
                                                *ngIf="
                                                    sort &&
                                                    sort['scored-' + meta]
                                                        ?.hasSort
                                                "
                                            ></cmps-icon>
                                            <cmps-icon
                                                *ngIf="
                                                    !(
                                                        sort &&
                                                        sort['scored-' + meta]
                                                            ?.hasSort
                                                    )
                                                "
                                            ></cmps-icon>
                                        </button>
                                    </th>
                                    <th class="subtitle sorting-column">
                                        <button
                                            type="button"
                                            (click)="
                                                onClickSort('passRate-' + meta)
                                            "
                                            class="btn bg-transparent p-0"
                                        >
                                            <span>Pass Rate</span>
                                            <cmps-icon
                                                [svgIcon]="
                                                    sort['passRate-' + meta]
                                                        ?.isAsc
                                                        ? 'chevron-up'
                                                        : 'chevron-down'
                                                "
                                                *ngIf="
                                                    sort &&
                                                    sort['passRate-' + meta]
                                                        ?.hasSort
                                                "
                                            ></cmps-icon>
                                            <cmps-icon
                                                *ngIf="
                                                    !(
                                                        sort &&
                                                        sort['passRate-' + meta]
                                                            ?.hasSort
                                                    )
                                                "
                                            ></cmps-icon>
                                        </button>
                                    </th>
                                </ng-template>
                            </tr>
                            <ng-template
                                ngFor
                                let-categoryRow
                                [ngForOf]="processedData"
                            >
                                <tr>
                                    <td class="text-center">
                                        {{ categoryRow.category }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <ng-template
                                        ngFor
                                        let-summ
                                        [ngForOf]="categoryRow.summary"
                                    >
                                        <td class="text-center">
                                            {{ summ.passed }}
                                        </td>
                                        <td class="text-center">
                                            {{ summ.scored }}
                                        </td>
                                        <td class="text-center">
                                            {{ summ.passRate }}
                                        </td>
                                    </ng-template>
                                </tr>

                                <tr
                                    *ngFor="
                                        let question of categoryRow.questions
                                    "
                                >
                                    <td></td>
                                    <td class="text-center">
                                        {{ question.question }}
                                    </td>
                                    <td class="text-center">
                                        {{ question.objective }}
                                    </td>
                                    <ng-template
                                        ngFor
                                        let-result
                                        [ngForOf]="question.results"
                                    >
                                        <td class="text-center">
                                            {{ result.passed }}
                                        </td>
                                        <td class="text-center">
                                            {{ result.scored }}
                                        </td>
                                        <td class="text-center">
                                            {{ result.passRate }}
                                        </td>
                                    </ng-template>
                                </tr>
                            </ng-template>
                        </table>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
